export default "/images/oneSubButtonDecor.png?58bfc807e501a05d365a55047a912b9f";